import M, { useRef as _, useState as h, useMemo as S, useEffect as E } from "react";
import { _ as T } from "../../../libServer-MKeVPlN9.js";
import { defaultBreakpoints as I, breakpoints as Y } from "./types.js";
function j(p, n) {
  const t = _(null), [m, k] = h("100%"), [s, x] = h(0), [f, w] = h(0), [g, C] = h(0), W = S(
    () => ({
      ...I,
      ...n.itemsPerBreakpoint
    }),
    [n.itemsPerBreakpoint]
  ), l = () => {
    t.current && (w(t.current.scrollWidth), C(t.current.clientWidth));
  }, o = S(
    () => ({
      shouldDisplayNext: s + g < f,
      shouldDisplayPrev: s > 0
    }),
    [s, g, f]
  );
  E(() => {
    const e = t.current;
    if (!e) return;
    const a = () => {
      const d = e.clientWidth ?? 0;
      let r = W.xs;
      for (const { size: v, key: u } of Y)
        if (window.matchMedia(`(min-width: ${v}px)`).matches) {
          r = W[u] ?? I[u];
          break;
        }
      const L = getComputedStyle(e), B = parseInt(L.gap) || 0;
      let y = 0;
      if (n.paddingElementWrapper && e.children.length) {
        const v = e.children[e.children.length - 1], u = getComputedStyle(v);
        y = parseInt(u.paddingRight);
      }
      const N = d - B * (r.items + (r.peek === 0 ? -1 : 0)) - y, R = r.items + (r.peek === 0 ? 0 : r.peek / 100), z = N / R;
      k(`${z}px`), l();
    };
    a(), l();
    const i = () => x(e.scrollLeft), c = T(() => {
      a(), l();
    }, 500);
    return e.addEventListener("scroll", i), window.addEventListener("resize", c), () => {
      e.removeEventListener("scroll", i), window.removeEventListener("resize", c);
    };
  }, [W, n.paddingElementWrapper, p]), E(l, [p]), E(() => {
    n.onNavigationStateChange?.(o);
  }, [o, n]);
  const P = () => {
    t.current && t.current.scrollTo({
      left: Math.max(0, s - t.current.offsetWidth),
      behavior: "smooth"
    });
  }, b = () => {
    t.current && t.current.scrollTo({
      left: Math.min(f - g, s + t.current.offsetWidth),
      behavior: "smooth"
    });
  }, D = (e) => {
    if (!t.current) return parseInt(m);
    const a = M.Children.count(p), i = {
      first: e === 0,
      last: e === a - 1
    }, c = () => {
      if (!n.paddingElementWrapper) return 0;
      const d = t.current?.children[e];
      if (!d) return 0;
      const r = getComputedStyle(d);
      return i.first ? parseInt(r.paddingLeft || "0") : i.last ? parseInt(r.paddingRight || "0") : 0;
    };
    return parseInt(m) + c();
  };
  return {
    carouselRef: t,
    shouldDisplayPrev: o.shouldDisplayPrev,
    shouldDisplayNext: o.shouldDisplayNext,
    scrollPrev: P,
    scrollNext: b,
    itemWidth: m,
    getItemWidth: D
  };
}
export {
  j as useCarousel
};
